module.exports = __webpack_public_path__ + "static/img/2015.9da013a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company/2015.png
// module id = K+vo
// module chunks = 1